import { Dispatch } from 'react'
import { InventoryFilter } from '../../models/Inventory'
import { EInventoryFilterActionTypes, InventoryFilterAction } from '../../types/redux/InventoryFilter'

export const setInventoryFilter = (value: InventoryFilter) => {
	return async (dispatch: Dispatch<InventoryFilterAction>) => {
		dispatch({ type: EInventoryFilterActionTypes.SET_INVENTORY_FILTER, payload: value })
	}
}
